module.exports = "../../app/cells/pages/guides/v2_journey_item_cell.rb";